module.exports = __webpack_public_path__ + "static/ojewola-812cc28df35ecdf4ad9e460a9f2907bc.png";